/* global System */

export default {
  Button: () => System.import(/* webpackChunkName: "Button" */ './index'),
}
